<template>
    <div class="contact-floating flex-col">

        <div class="box_93 flex-col">
            <div class="group_3 flex-col">
                <div class="dialog_header flex-col" >
                    <div class="box_11 flex-row">
                        <span class="text_18">联系我们</span>
                        <img
                                class="icon_call"
                                referrerpolicy="no-referrer"
                                src="../../assets/footer/chpc_footer_call.png"
                        />
                        <span class="text_phone">010-58204887</span>
                        <img
                                @click="close"
                                class="icon_close"
                                referrerpolicy="no-referrer"
                                src="../../assets/common/index_contact_01.png"
                        />
                    </div>
                    <div class="image-wrapper_3 flex-row">
                        <img class="header_image_4" referrerpolicy="no-referrer" src="../../assets/footer/chpc_footer_line_04.png"/>
                    </div>
                    <div class="header_box_11 flex-row">
                        <div class="text-group_4 flex-col">
                            <span class="header_text_18">为您打造业务风控与合规管理的专业定制化咨询服务方案</span>
                            <span class="header_text_19">助力企业实现可持续发展</span>
                        </div>
                    </div>
                </div>

                <div class="box_12 flex-row">
                    <div class="image-text_159 flex-row justify-between">
                        <img
                                class="thumbnail_2"
                                referrerpolicy="no-referrer"
                                src="../../assets/common/index_contact_02.png"
                        />
                        <span class="text-group_2">姓名</span>
                    </div>
                    <input
                            class="form-input"
                            v-model="formData.name"/>
                </div>
                <div class="box_13 flex-row">
                    <div class="image-text_160 flex-row justify-between">
                        <img
                                class="thumbnail_3"
                                referrerpolicy="no-referrer"
                                src="../../assets/common/index_contact_02.png"
                        />
                        <span class="text-group_3">电话</span>
                    </div>
                    <input class="form-input" v-model="formData.phone"/>
                </div>
                <div class="box_13 flex-row">
                    <div class="image-text_160 flex-row justify-between">
                        <img
                                class="thumbnail_3"
                                referrerpolicy="no-referrer"
                                src="../../assets/common/index_contact_02.png"
                        />
                        <span class="text-group_3">公司</span>
                    </div>
                    <input class="form-input" v-model="formData.company"/>
                </div>

                <div class="text-wrapper_5 flex-row">
                    <span class="text_20">邮箱</span>
                    <input
                            class="form-input"
                            v-model="formData.email"/>
                </div>
                <div class="text-wrapper_6 flex-col">
                    <textarea class="message-input" v-model="formData.content" placeholder="在此留言（最多100字）" maxlength="100"></textarea>
                </div>
                <div class="text-wrapper_7 flex-col" @click="handleClick()">
                    <span class="text_22">提交</span>
                </div>

            </div>

        </div>

    </div>
</template>
<script>
    import {isNull,validateEmail} from "../../common/testFun";

    export default {
        data() {
            return {
                formData: {
                    name: '',
                    company: '',
                    phone: '',
                    email: '',
                    content: ''
                },
            };
        },
        methods: {
            resetForm() {
                this.$set(this, 'formData', {
                    name: '',
                    company: '',
                    phone: '',
                    email: '',
                    content: ''
                });
            },
            validatePhoneNumber(phone) {
                // 先移除所有空格
                const cleanedPhone = phone.replace(/\s+/g, '');

                // 检查是否包含"转"字
                if (cleanedPhone.includes("转")) {
                    // 分割主号码和分机号
                    const parts = cleanedPhone.split("转");

                    // 必须有且只有两部分：主号码 + 分机号
                    if (parts.length !== 2) {
                        return false;
                    }

                    const [mainNumber, extension] = parts;

                    // 验证分机号必须是数字
                    if (!/^\d+$/.test(extension) || extension === "") {
                        return false;
                    }

                    // 继续验证主号码部分
                    return this.validateMainNumber(mainNumber);
                }

                // 不含"转"字时直接验证号码
                return this.validateMainNumber(cleanedPhone);
            },

            // 验证主号码（手机或座机）
            validateMainNumber(number) {
                // 手机号验证：1开头，11位纯数字
                if (/^1\d{10}$/.test(number)) {
                    return true;
                }

                // 座机号验证：区号(3-4位)-号码(7-8位)
                if (/^\d{3,4}-\d{7,8}$/.test(number)) {
                    return true;
                }

                return false;
            },
            handleClick() {
                console.log('提交表单数据:', this.formData);
                if (isNull(this.formData.name)) {
                    this.$message.warning('请输入姓名');
                    return;
                }
                if (isNull(this.formData.phone)) {
                    this.$message.warning('请输入电话号码');
                    return;
                } else if (this.validatePhoneNumber(this.formData.phone)) {
                    //this.$message.warning('电话格式不正确');
                    //return;
                }
                if (isNull(this.formData.company)) {
                    this.$message.warning('请输入公司名称');
                    return;
                }
                if (!isNull(this.formData.email)) {
                    if (this.formData === ' ') {
                        console.log("null")
                    } else {
                        let isok = validateEmail(this.formData.email)
                        if (!isok) {
                            this.$message.warning('邮箱格式不正确');
                            return;
                        }
                    }

                }
                let data = this.formData;
                let that = this;
                this.$HTTP.addConsult(data).then(resp => {
                    if (resp.code == 200) {
                        that.$message.success("信息已提交成功!")
                        this.resetForm();
                        this.$emit('closeMobileContact', 1);
                    }
                });

            },
            close(){
                this.resetForm();
                this.$emit('closeMobileContact', 1);
            }
        }
    };
</script>


<style scoped lang="css">
    .contact-floating {
        position: fixed;
        bottom: 2px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 99999;
        max-width: 100%;
        width: 100%;
        max-height: 80vh;
        height: auto;
        margin: 0 10px 10px 10px;
        display: flex;
        flex-direction: column;
        /*background-color: rgba(255, 255, 255, 0.9);*/

        border-radius: 10px;

        overflow: hidden;
        box-sizing: border-box;
    }

    .flex-col {
        display: flex;
        flex-direction: column;
    }

    .group_3 {
        background-color: rgba(255, 255, 255, 1);
        border-radius: 10px;
        position: relative;
        width: 100%;
        height: 100%;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        padding-bottom: 20px;
        max-height: calc(90vh - 20px);
        box-sizing: border-box;
    }

    .dialog_header {
        background-color: rgba(0, 134, 131, 1);
        border-radius: 10px 10px 0px 0px;
        width: 100%;
        z-index: 1000;
        flex-shrink: 0;
        position: sticky;
        top: 0;
        box-sizing: border-box;
    }

    .box_11 {
        border-radius: 10px 10px 0px 0px;
        max-width: 100%;
        min-height: 60px;
        position: relative;
        display: flex;
        align-items: center;
        padding: 0 20px;
        box-sizing: border-box;
    }

    .text_18 {
        width: 80px;
        height: 28px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 20px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 28px;
        margin-right: 10px; /* 调整右边距 */
        box-sizing: border-box; /* 包括内边距和边框在内 */
    }

    .icon_call {
        width: 16px;
        height: 16px;
        margin: 12px 5px 0 15px;
        box-sizing: border-box;
    }

    .text_phone {
        height: 28px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 14px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 29px;
        margin: 10px 10px 0 5px; /* 调整间距 */
        box-sizing: border-box; /* 包括内边距和边框在内 */
    }

    /* 关闭图标 - 修复位置 */
    .icon_close {
        width: 24px;
        height: 24px;
        position: absolute; /* 绝对定位 */
        right: 15px; /* 距离右边15px */
        top: 18px; /* 垂直居中 */
        cursor: pointer;
        box-sizing: border-box; /* 包括内边距和边框在内 */
    }

    .image-wrapper_3 {
        margin: 2px 0 0 20px;
        box-sizing: border-box; /* 包括内边距和边框在内 */
    }

    .header_image_4 {
        width: 62px;
        height: 1px;
        box-sizing: border-box; /* 包括内边距和边框在内 */
    }

    .header_box_11 {
        margin: 20px 52px 0 4px;
        box-sizing: border-box; /* 包括内边距和边框在内 */
    }

    .text-group_4 {
        box-sizing: border-box; /* 包括内边距和边框在内 */
    }

    .header_text_18 {
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 12px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 500;
        text-align: left;
        margin: -10px 0 0 20px;
        white-space: nowrap;
        line-height: 20px;
        box-sizing: border-box; /* 包括内边距和边框在内 */
    }

    .header_text_19 {
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 12px;
        text-align: left;
        white-space: nowrap;
        line-height: 20px;
        margin: 5px 0 20px 20px;
        box-sizing: border-box; /* 包括内边距和边框在内 */
    }

    .box_12 {
        background-color: rgba(249, 249, 251, 1);
        border-radius: 4px;
        max-width: 386px;
        height: 47px;
        margin: 24px 0 0 33px;
        box-sizing: border-box; /* 包括内边距和边框在内 */
    }

    .image-text_159 {
        width: 43px;
        height: 22px;
        margin: 13px 0 0 10px;
        box-sizing: border-box; /* 包括内边距和边框在内 */
    }

    .thumbnail_2 {
        width: 8px;
        height: 8px;
        margin-top: 7px;
        box-sizing: border-box; /* 包括内边距和边框在内 */
    }

    .text-group_2 {
        width: 32px;
        height: 22px;
        overflow-wrap: break-word;
        color: rgba(37, 37, 37, 1);
        font-size: 16px;
        text-align: left;
        white-space: nowrap;
        line-height: 22px;
        box-sizing: border-box; /* 包括内边距和边框在内 */
    }

    .box_13 {
        background-color: rgba(249, 249, 251, 1);
        border-radius: 4px;
        max-width: 386px;
        height: 47px;
        margin: 16px 0 0 33px;
        box-sizing: border-box; /* 包括内边距和边框在内 */
    }

    .image-text_160 {
        width: 43px;
        height: 22px;
        margin: 13px 0 0 10px;
        box-sizing: border-box; /* 包括内边距和边框在内 */
    }

    .justify-between {
        display: flex;
        justify-content: space-between;
        box-sizing: border-box; /* 包括内边距和边框在内 */
    }

    .flex-row {
        display: flex;
        flex-direction: row;
        box-sizing: border-box; /* 包括内边距和边框在内 */
    }

    .thumbnail_3 {
        width: 8px;
        height: 8px;
        margin-top: 7px;
        box-sizing: border-box; /* 包括内边距和边框在内 */
    }

    .text-group_3 {
        width: 32px;
        height: 22px;
        overflow-wrap: break-word;
        color: rgba(37, 37, 37, 1);
        font-size: 16px;
        text-align: left;
        white-space: nowrap;
        line-height: 22px;
        box-sizing: border-box;
    }

    .text-wrapper_5 {
        background-color: rgba(249, 249, 251, 1);
        border-radius: 4px;
        height: 47px;
        max-width: 386px;
        margin: 16px 0 0 33px;
        box-sizing: border-box;
    }

    .text_20 {
        width: 32px;
        height: 22px;
        overflow-wrap: break-word;
        color: rgba(37, 37, 37, 1);
        font-size: 16px;
        text-align: left;
        white-space: nowrap;
        line-height: 22px;
        margin: 13px 0 0 21px;
        box-sizing: border-box;
    }

    .text-wrapper_6 {
        background-color: rgba(249, 249, 251, 1);
        border-radius: 4px;
        height: 120px;
        width: 386px;
        margin: 13px 0 0 33px;
        flex-shrink: 0;
        box-sizing: border-box;
    }

    /* 提交按钮 - 修复居中问题 */
    .text-wrapper_7 {
        background-color: rgba(0, 134, 131, 1);
        border-radius: 4px;
        height: 42px;
        width: 80%;
        margin: 20px auto;
        flex-shrink: 0;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
    }

    /* 提交按钮文本 - 移除固定margin */
    .text_22 {
        color: rgba(255, 255, 255, 1);
        font-size: 20px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: center;
        white-space: nowrap;
        /* 移除固定 margin */
        box-sizing: border-box;
    }

    .form-input {
        flex: 1;
        border: none;
        outline: none;
        background: transparent;
        color: #333;
        font-size: 16px;
        padding-left: 10px;
        box-sizing: border-box;
    }

    .message-input {
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        background: transparent;
        resize: none;
        padding: 10px;
        color: #999;
        font-size: 16px;
        box-sizing: border-box; /* 包括内边距和边框在内 */
    }

    @media (max-width: 600px) {
        .contact-floating {
            left: 0;
            transform: none;
            width: 100%;
            max-width: 100%;
            margin: 0;
            border-radius: 0;
            box-shadow: none;
        }

        .group_3 {
            padding: 0 0 10px;
            height: 100%;
        }

        .box_11 {
            border-radius: 0;
            min-height: 45px;
            padding: 0 15px; /* 增加内边距 */
        }
        .text_18 {
            margin: 10px 0 0 0;
            font-size: 18px;
        }
        .icon_close {
            top: 15px;
            right: 15px;
            width: 20px;
            height: 20px;
        }

        .box_12,
        .box_13,
        .text-wrapper_5 {
            height: 42px;
            margin-top: 12px;
            width: 90%;
            margin-left: 5%;
        }

        .text-wrapper_6 {
            height: 70px;
            width: 90%;
            margin-left: 5%;
        }

        .text-wrapper_7 {
            margin: 12px auto;
            width: 80%;
            max-width: 500px;
            height: 36px;
        }
        .text_22 {
            font-size: 16px;
        }
    }
</style>
